export const SERVER_EXPERIMENTS_HEADER = 'x-experiments'

// We have twp keys so we have independent control over staging and prod
// There are probably better solutions like audience segmentation
export const SKELETON_EXPERIMENT_KEYS = [
  'server-hack-skeletons-v2',
  'server-tst-hack-skeletons'
]
